import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModuleDetails from './ModuleDetails';
import ModuleTable from './ModuleTable';
import styles from './ModuleLibrary.module.css';
import { getModulesWithTemplates } from '../../api/moduleService';
import Header from '../Shared/Header';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useTokenCheck } from '../../hooks/useTokenCheck';
import CenteredSpinner from '../Shared/CenteredSpinner';

export default function ModuleLibrary() {
  useTokenCheck();
  const { t } = useTranslation();
  const history = useHistory();
  const [refreshData, setRefreshData] = useState(true);
  const { modulesList, loading } = useSelector(
    (state) => state.moduleReducer.moduleLibrary
  );
  const [selectedModule, setSelectedModule] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    if (refreshData) {
      dispatch(getModulesWithTemplates());
      setRefreshData(false);
    }
  }, [refreshData]);

  return (
    <div className={styles.moduleLibraryContainer}>
      <Header
        title={t('modules')}
        newButton
        onNewClicked={() => history.push('/addmodule')}
        refreshButton
        onRefreshClicked={() => setRefreshData(true)}
      />

      {loading ? (
        <CenteredSpinner />
      ) : (
        <div className={styles.content}>
          <ModuleTable
            moduleList={modulesList}
            setModuleDetails={setSelectedModule}
          />
          {selectedModule && (
            <div className={styles.moduleDetailsContainer}>
              <ModuleDetails module={selectedModule} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
